// src/features/townBudget/components/programs/Program_TransfersIn.jsx

import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

/**
 * Town Program: Transfers In From
 *
 * Firestore docId should match your stored doc:
 *   revenues_transfers_in_from
 */
export const PROGRAM_TRANSFERS_IN_CONFIG = {
  fullName: "Transfers In From",
  docId: "revenues_transfers_in_from",

  fieldDefs: [
    {
      key: "capitalProjects",
      label: "Capital Projects",
      valueType: "currency",
      sources: [{ block: "Transfers In From", key: "Capital Projects" }],
      group: "other",
      defaultVisible: true,
    },
    {
      key: "generalFund",
      label: "General Fund",
      valueType: "currency",
      sources: [{ block: "Transfers In From", key: "General Fund" }],
      group: "other",
      defaultVisible: true,
    },
  ],

  tables: [
    {
      id: "adopted",
      title: "Transfers In – Approved",
      sectionKey: "Approved",
      fields: ["capitalProjects", "generalFund"],
      columnStyles: {
        year: { width: "90px", minWidth: "90px" },
        capitalProjects: { minWidth: "160px" },
        generalFund: { minWidth: "140px" },
      },
    },
    {
      id: "actual",
      title: "Transfers In – Actual",
      sectionKey: "Actual",
      fields: ["capitalProjects", "generalFund"],
      columnStyles: {
        year: { width: "90px", minWidth: "90px" },
        capitalProjects: { minWidth: "160px" },
        generalFund: { minWidth: "140px" },
      },
    },
  ],

  chartTitle: "Transfers In (Actual preferred)",
};

export function ProgramTransfersIn(props) {
  return (
    <ProgramBudget
      programId="revenues_transfers_in_from"
      config={PROGRAM_TRANSFERS_IN_CONFIG}
      {...props}
    />
  );
}
